import React from "react";
import { TextField } from "@mui/material";
import GroupAllUsers from "../FieldTags/GroupAllUsers";
import pullListLabels from "../../util/PullListLabels";
import HistoryLogElement from "./HistoryLogElement";

const PullListComment = ({ pullListComment, handleChange, pullLists, required }) => {

    return (
        <div className="planField">
            <GroupAllUsers />
            <TextField
                id="pullListComment-field"
                name="pullListComment"
                label={required ? pullListLabels.disposalReason : pullListLabels.pullListComment}
                InputLabelProps={{ shrink: true }}
                type="text"
                required={required}
                value={pullListComment ? pullListComment : ""}
                onChange={(e) => handleChange("pullListComment", e.target.value)}
                multiline
                minRows={1}
                className="fullLength"
            />
            <HistoryLogElement pullLists={pullLists} label={"pullListComment"} />
        </div>
    );
};

export default PullListComment;